import { useQuery } from '@tanstack/react-query'
import { api } from '@api'

export interface ChatbotConversationItem {
  id: string
  title: string | null
  createdAt: string
  updatedAt: string | null
}

interface ListChatbotConversationsResponse {
  conversations: ChatbotConversationItem[]
}

export interface ChatbotConversation extends ChatbotConversationItem {
  messages: { role: 'user' | 'model'; content: string; timestamp: string }[]
}

const fetchChatbotConversations = async (): Promise<ChatbotConversationItem[]> => {
  const { data } = await api.get<ListChatbotConversationsResponse>('/ft_chatbot/conversations')
  return data.conversations
}

export const fetchChatbotConversation = async (id: string): Promise<ChatbotConversation> => {
  const { data } = await api.get<ChatbotConversation>(`/ft_chatbot/conversations/${id}`)
  return data
}

export const useFtChatbotConversations = (enabled: boolean = true) => {
  return useQuery<ChatbotConversationItem[]>({
    queryKey: ['chatbot-conversations'],
    queryFn: fetchChatbotConversations,
    enabled,
  })
}
